import React from 'react';
import { COMMAND_NAV_GROUPS } from './auditorAgentRoutes';

/**
 * Slim left command list for Auditor Business tab.
 * Collapsible so Corporate Records / specialist workspaces can use full width.
 */
export default function AuditorCommandNav({
  activeSlug = 'command',
  onSelect,
  collapsed = false,
  onToggleCollapsed,
}) {
  if (collapsed) {
    return (
      <nav className="auditor-command-nav auditor-command-nav--collapsed" aria-label="Auditor specialists">
        <button
          type="button"
          className="auditor-command-nav-expand"
          onClick={() => onToggleCollapsed?.(false)}
          title="Expand COMMAND"
          aria-expanded="false"
        >
          <span className="auditor-command-nav-expand-label">CMD</span>
          <span className="auditor-command-nav-expand-icon" aria-hidden>›</span>
        </button>
      </nav>
    );
  }

  return (
    <nav className="auditor-command-nav" aria-label="Auditor specialists">
      <div className="auditor-command-nav-title-row">
        <div className="auditor-command-nav-title">COMMAND</div>
        <button
          type="button"
          className="auditor-command-nav-collapse"
          onClick={() => onToggleCollapsed?.(true)}
          title="Collapse COMMAND"
          aria-expanded="true"
        >
          ‹
        </button>
      </div>
      <div className="auditor-command-nav-list">
        {COMMAND_NAV_GROUPS.map((group) => (
          <div key={group.label} className="auditor-command-nav-section">
            <div className="auditor-command-nav-section-label">{group.label}</div>
            {group.items.map((item) => {
              const active = activeSlug === item.slug;
              return (
                <button
                  key={item.slug}
                  type="button"
                  className={`auditor-command-nav-item${item.featured ? ' is-featured' : ''}${active ? ' is-active' : ''}`}
                  aria-current={active ? 'page' : undefined}
                  onClick={() => onSelect?.(item.slug)}
                >
                  <span className="auditor-command-nav-item-label">{item.label}</span>
                  {item.meta ? (
                    <span className="auditor-command-nav-item-meta">{item.meta}</span>
                  ) : null}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </nav>
  );
}
